import {DataChunk, Perspective, SortingOptionsType, SortingStrategy, SortingStrategyId} from '@selpia/shared/models';

import {DataBatchTools} from './data-batch-tools';
import {ArrayTools} from './array-tools';

export class SortingTools {
  static createSortingStrategyFromId(strategyId: SortingStrategyId): SortingStrategy<DataChunk> {
    switch (strategyId) {
      default:
        console.warn('Invalid sortingStrategyId', strategyId);
        return this.createSortingStrategyFromId(SortingStrategyId.AlphabeticAsc);
      case SortingStrategyId.AlphabeticAsc:
        return (dataChunks, options: SortingOptionsType) =>
          [...dataChunks].sort((a, b) =>
            a.isTotal || b.isTotal
              ? this.compareWithTotal(a, b)
              : this.compareDataChunksAlphabeticallyByDimensionName(a, b, options.perspective),
          );
      case SortingStrategyId.AlphabeticDesc:
        return (dataChunks, options: SortingOptionsType) =>
          [...dataChunks].sort((a, b) =>
            a.isTotal || b.isTotal
              ? this.compareWithTotal(a, b)
              : this.compareDataChunksAlphabeticallyByDimensionName(b, a, options.perspective),
          );
      case SortingStrategyId.FocusMeasureAsc:
        return (dataChunks, options: SortingOptionsType) =>
          [...dataChunks].sort((a, b) =>
            a.isTotal || b.isTotal
              ? this.compareWithTotal(a, b)
              : DataBatchTools.compareDataChunksValues(a, b, options.measureCode, options.period, options.date),
          );
      case SortingStrategyId.FocusMeasureDesc:
        return (dataChunks, options: SortingOptionsType) =>
          [...dataChunks].sort((a, b) =>
            a.isTotal || b.isTotal
              ? this.compareWithTotal(a, b)
              : DataBatchTools.compareDataChunksValues(b, a, options.measureCode, options.period, options.date),
          );
    }
  }

  static compareDataChunksAlphabeticallyByDimensionName(a: DataChunk, b: DataChunk, perspective: Perspective): number {
    return ArrayTools.compareStringsAlphabeticalSort(
      this.getDimensionName(a, perspective),
      this.getDimensionName(b, perspective),
    );
  }

  static getDimensionName(dataChunk: DataChunk, perspective: Perspective): string {
    return (
      DataBatchTools.findDimensionItemBy(
        {dimensionLevelName: perspective.focusDimensionLevel.name},
        dataChunk.dimensionItems,
      )?.name ?? ''
    );
  }

  static compareWithTotal(a: DataChunk, b: DataChunk): number {
    if (a.isTotal) {
      return -1;
    }
    if (b.isTotal) {
      return 1;
    }
    return 0;
  }
}

